interface EmptyStateMessageProps {
  memberFilter: 'all' | 'current' | 'active';
}

export function EmptyStateMessage({ memberFilter }: EmptyStateMessageProps) {
  return (
    <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
      <p>No member statistics found.</p>
      {memberFilter !== 'all' && <p>Try selecting "All members" to see more results</p>}
    </div>
  );
}
